import { getExportsUrl } from '../../store/appReducer'
import { DATASOURCES, CLEAR_STATE } from '../../constants'

// ------------------------------------
// Constants
// ------------------------------------
const PREFIX = 'Exports.'
export const UPDATE_EXPORT_ID = `${PREFIX}UPDATE_EXPORT_ID`
export const UPDATE_EXPORT_URL = `${PREFIX}UPDATE_EXPORT_URL`
export const RESET_STATE = `${PREFIX}RESET_STATE`
// ------------------------------------
// Actions
// ------------------------------------
export const updateExportId = id => ({
  type: UPDATE_EXPORT_ID,
  payload: id,
})
export const updateExportUrl = url => ({
  type: UPDATE_EXPORT_URL,
  payload: url,
})
export const resetState = () => ({
  type: RESET_STATE,
})

export const setExportId = match => (dispatch, getState) => {
  const {
    exportId,
  } = match.params
  dispatch(updateExportId(exportId))
}

export const getExports = () => (dispatch, getState) => {
  const {
    exportId,
  } = getState().exports

  return dispatch(getExportsUrl(exportId))
    .then(() => {
      const {
        [DATASOURCES.EXPORTS]: exports,
      } = getState().app.dataSources

      dispatch(updateExportUrl(exports.data.url))
    })
}

const initialState = {
  exportId: null,
  url: null,
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_EXPORT_ID]: (state, action) => ({
    ...state, exportId: action.payload,
  }),
  [UPDATE_EXPORT_URL]: (state, action) => ({
    ...state, url: action.payload,
  }),
  [RESET_STATE]: (state, action) => ({
    ...initialState,
  }),
  [CLEAR_STATE]: (state, action) => ({
    ...initialState,
  }),
}

// ------------------------------------
// Reducer
// ------------------------------------
export default function exportsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/legacy/pages/Exports/module.js